import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";
import { technologyGroups } from "@/mocks/technologies";

export default function Technologies() {
  return (
    <Layout>
      <PageHero
        title="Technologies"
        subtitle="Our Technology Stack"
        description="A complete view of the enterprise technologies Mitaja supports across infrastructure, network, database, application, Microsoft, cloud, web, mobile, and AI practice areas."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <SectionHeader
            title="Complete Technology List"
            description="Technologies applied across enterprise and government delivery engagements, organized by practice area."
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {technologyGroups.map((group) => (
              <div key={group.title} className="card-base p-6 flex flex-col">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className={`${group.icon} text-primary-600 text-lg`} aria-hidden="true"></i>
                  </div>
                  <h3 className="text-lg font-bold text-foreground-900">
                    {group.title}
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {group.technologies.map((tech) => (
                    <span
                      key={tech}
                      className="inline-flex items-center px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 text-sm font-medium"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-background-100 rounded-lg p-6 border border-background-200/80">
            <h3 className="text-lg font-bold text-foreground-900 mb-3">
              How We Apply These Technologies
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Mitaja applies this technology stack across enterprise infrastructure and network engineering, database and data platform services, application and platform engineering, Microsoft Power Platform and SharePoint solutions, cloud engineering, and web, mobile, and AI-enabled digital delivery. View our capabilities to learn how these technologies support government and enterprise programs.
            </p>
            <div className="mt-5">
              <Link to="/capabilities" className="btn-primary">
                Explore Capabilities
                <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <CTAPanel
        title="Need a Specific Technology?"
        description="Contact Mitaja to discuss how our technology stack and technical delivery teams can support your program requirements."
        secondaryAction={{ label: "Contact Us", href: "/contact" }}
        variant="dark"
      />
    </Layout>
  );
}